import React from 'react';
import { HelpCircle } from 'lucide-react';

export function OpenQuestions({ items }) {
  if (!items?.length) return null;
  const toForm = (section) => {
    window.dispatchEvent(new CustomEvent('kojiru:comment-section', { detail: section }));
    document.querySelector('[data-testid="comment-form"]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  return (
    <section className="mb-10 space-y-3" data-testid="open-questions">
      <h2 className="text-base md:text-lg font-semibold flex items-center gap-2"><HelpCircle className="w-4 h-4 text-amber-300" /> Open questions</h2>
      {items.map((q) => (
        <article key={q.id} className="rounded-2xl border border-amber-500/30 bg-amber-500/[0.04] p-5" data-testid={`open-question-${q.id}`}>
          <div className="flex flex-wrap items-center gap-2 mb-2">
            <span className="font-mono text-xs text-gray-500">{q.id}</span>
            <span className="rounded-full border border-amber-400/40 px-2.5 py-0.5 text-[11px] text-amber-200" data-testid={`open-question-${q.id}-status`}>{q.status || 'Open for comment'}</span>
          </div>
          <h3 className="text-base font-semibold text-white">{q.title}</h3>
          <p className="text-sm text-gray-300 leading-relaxed mt-1">{q.intro}</p>
          <ol className="mt-3 space-y-2 text-sm text-gray-300 list-decimal pl-5">
            {q.items.map((it) => <li key={it.name}><span className="font-semibold text-white">{it.name}.</span> {it.text}</li>)}
          </ol>
          <p className="text-sm text-amber-100 mt-3" data-testid={`open-question-${q.id}-ask`}>{q.ask}</p>
          <button type="button" onClick={() => toForm(q.section)} className="mt-3 rounded-full border border-amber-400/50 px-4 py-1.5 text-xs text-amber-200 hover:bg-white/5 transition-colors" data-testid={`open-question-${q.id}-comment-btn`}>Comment on this question</button>
        </article>
      ))}
    </section>
  );
}
